export default class ModalQueryPathController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} path
	 */
	constructor($uibModalInstance, path) {
		this.path = path;
	}
}
